import { Component } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";

import Img from "../assets/mail.svg";
import Styles from "bundle-text:../styles/_verifyEmailModal.scss";

interface VerifyEmailModalProps {
  show: boolean;
  onLater: () => void;
  onNow: () => void;
}

const VerifyEmailModal: Component<VerifyEmailModalProps> = (props) => {
  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show}>
        <div className="great-content">
          <h1>Do you want to verify a professional email now or later?</h1>
          <p>
            A professional email address can be used as the sender for your
            email campaigns, which will boost your delivery rate. Make sure to
            verify your email later if you choose not to do it now.
          </p>
          <img src={Img} alt="clock" />
          <div>
            <button onClick={props.onLater}>Later</button>
            <button onClick={props.onNow}>Now</button>
          </div>
        </div>
      </DefaultModal>
    </>
  );
};

export default VerifyEmailModal;
